/**
 * assets/littleg-lab-init.js — LEGACY-CLEANUP-15 legacy lab bootstrap
 * Owner: legacy LittleG Lab bootstrap, legacy P1–P6 island slider, view switch fallback, and geospatial nature route handoff.
 * Boundary: legacy lab only; not part of /pages/game P0 daily-card chain; no daily-card write; no checkout truth; no GFun ledger.
 * Alignment: Esri Geospatial Framework & Location Intelligence Standards.
 */
(function () {
  'use strict';

  window.__LITTLEG_LAB_INIT_V53_LOAD_COUNT = (window.__LITTLEG_LAB_INIT_V53_LOAD_COUNT || 0) + 1;

  function $id(id) { return document.getElementById(id); }
  function log() { try { console.log.apply(console, arguments); } catch (_) {} }

  function debounce(fn, wait) {
    var t = null;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function getServerData() {
    window.LITTLEG_SERVER_DATA = window.LITTLEG_SERVER_DATA || {};
    return window.LITTLEG_SERVER_DATA;
  }

  function normalisePath(value) {
    var path = String(value || '/')
      .split('?')[0]
      .split('#')[0]
      .replace(/\\/g, '/')
      .replace(/\/{2,}/g, '/')
      .toLowerCase()
      .replace(/^\/[a-z]{2,3}(?:-[a-z0-9]{2,8})*(?=\/)/i, '');
    if (path.length > 1) path = path.replace(/\/+$/, '');
    return path || '/';
  }

  function currentParams() {
    try { return new URLSearchParams(window.location.search || ''); } catch (_) { return new URLSearchParams(''); }
  }

  function isNatureRoute() {
    var path = normalisePath(window.location.pathname);
    var params = currentParams();
    return !!document.querySelector('[data-lg-nature-root]') || (path === '/pages/game' && (params.get('market') === 'green-city-service' || params.get('route') === 'nature' || params.get('nature') === 'true'));
  }

  function markLegacyLab(root) {
    root = root || document.documentElement;
    try {
      root.setAttribute('data-legacy-cleanup-batch', 'LEGACY-CLEANUP-15');
      root.setAttribute('data-legacy-lab-owner', 'littleg-lab-init');
      root.setAttribute('data-lab-route-scope', 'legacy-lab-only');
      root.setAttribute('data-daily-card-storage-key', 'not-written');
      root.setAttribute('data-no-daily-card-write', 'true');
    } catch (_) {}
  }

  function bootNatureRoute() {
    var root = document.querySelector('[data-lg-nature-root]');
    if (!root && !isNatureRoute()) return false;

    markLegacyLab(root || document.documentElement);
    if (document.body) {
      document.body.setAttribute('data-littleg-route', 'nature');
      document.body.setAttribute('data-legacy-cleanup-batch', 'LEGACY-CLEANUP-15');
      document.body.setAttribute('data-legacy-lab-owner', 'littleg-lab-init');
    }

    try {
      window.LITTLEG_SERVER_DATA = window.LITTLEG_SERVER_DATA || {};
      window.LITTLEG_SERVER_DATA.currentRoute = 'nature';
      window.LITTLEG_SERVER_DATA.natureRouteUrl = window.LITTLEG_SERVER_DATA.natureRouteUrl || '/pages/game?market=green-city-service';
      window.LITTLEG_SERVER_DATA.legacyCleanupBatch = 'LEGACY-CLEANUP-15';
    } catch (_) {}

    if (!document.__lgNatureRouteBound) {
      document.__lgNatureRouteBound = true;
      document.addEventListener('littleg:nature-route-change', function (event) {
        var detail = event && event.detail ? event.detail : {};
        if (document.body) document.body.setAttribute('data-littleg-current-island', detail.island || '');
        try { window.sessionStorage.setItem('littleg:last:nature-island', detail.island || ''); } catch (_) {}
      });
    }

    try {
      document.dispatchEvent(new CustomEvent('littleg:nature:ready', { detail: { source: 'littleg-lab-init', route: 'nature', rootFound: !!root, legacyCleanupBatch: 'LEGACY-CLEANUP-15' } }));
    } catch (_) {}

    if (window.LittleGNavigation && typeof window.LittleGNavigation.syncActiveState === 'function') {
      try { window.LittleGNavigation.syncActiveState(); } catch (_) {}
    }

    removeBootScreen();
    log('[littleg-lab-init] Geospatial nature route detected. Inline Path Walker owns the state. LEGACY-CLEANUP-15');
    return true;
  }

  var CONFIG = { BOOT_FADE_DELAY_MS: 900, BOOT_REMOVE_AFTER_MS: 600, PATH_UPDATE_DEBOUNCE_MS: 120, RETURN_HIGHLIGHT_MS: 1800, AUTO_TIME_INTERVAL_MS: 12000 };
  
  /* Esri Geospatial Lifecycle & Taxonomy Alignment */
  var PHASES = [
    { phase: 1, key: 'survey',  title_zh: '地理測繪與數據採集', title_en: 'Geospatial Surveying & Data Collection', goal_zh: '觀察城市空間，建立地理空間感知。', world: 'World 3: 位置智能感知' },
    { phase: 2, key: 'plan',    title_zh: '國土空間規劃與設計', title_en: 'Territorial Spatial Planning & Design',   goal_zh: '分析地理數據，研判空間規劃藍圖。', world: 'World 6: 專業空間服務' },
    { phase: 3, key: 'build',   title_zh: '工程建設與生態保育', title_en: 'Implementation & Ecological Conservation', goal_zh: '項目空間落地，平衡開發與生態保育。', world: 'World 6: 專業空間服務' },
    { phase: 4, key: 'operate', title_zh: '空間資產運營與數據管理', title_en: 'Spatial Asset Operations & Management', goal_zh: '資產空間圖譜運營，實現長效增值。', world: 'World 9: 商業空間運營' },
    { phase: 5, key: 'renew',   title_zh: '城市空間更新與數字孿生', title_en: 'Urban Spatial Renewal & Digital Twin',   goal_zh: '城市空間再生，實景三維智慧升級。', world: 'World 6: 專業空間服務' },
    { phase: 6, key: 'impact',  title_zh: '空間治理與公眾科學實踐', title_en: 'Geospatial Governance & Citizen Science', goal_zh: '地理空間治理，驅動公眾科學實踐。', world: 'World 7: 智慧空間生活' }
  ];
  window.LITTLEG_PHASES = window.LITTLEG_PHASES || PHASES;

  function hydratePhaseBadges() {
    var nodes = document.querySelectorAll('[data-lg-phase]');
    if (!nodes || !nodes.length) return;
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var p = parseInt(el.getAttribute('data-lg-phase') || '0', 10);
      if (!p) continue;
      var found = null;
      for (var j = 0; j < PHASES.length; j++) { if (PHASES[j].phase === p) { found = PHASES[j]; break; } }
      if (!found) continue;
      if (!el.__lgHydrated) { el.__lgHydrated = true; el.textContent = 'PHASE ' + found.phase + ' · ' + found.title_zh + ' (' + found.title_en + ') · ' + found.world; el.setAttribute('title', found.goal_zh); }
    }
  }

  function ensureSwitchView() {
    if (typeof window.switchView === 'function') return;
    window.switchView = function (mode) {
      mode = String(mode || '').trim();
      if (!mode) return;
      var mapViewport = $id('map-viewport');
      var storyPanel  = $id('view-story');
      var studioPanel = $id('view-studio');
      function show(el, yes) { if (!el) return; el.style.display = yes ? 'block' : 'none'; el.setAttribute('aria-hidden', yes ? 'false' : 'true'); }
      var btns = document.querySelectorAll('.view-btn');
      for (var i = 0; i < btns.length; i++) {
        var b = btns[i];
        var tgt = String(b.getAttribute('data-target') || '');
        var fallback = (b.textContent || '').toLowerCase();
        var isActive = tgt ? (tgt === mode) : (mode === 'map' ? (fallback.indexOf('地圖') !== -1 || fallback.indexOf('map') !== -1) : mode === 'story' ? (fallback.indexOf('故事') !== -1 || fallback.indexOf('story') !== -1) : mode === 'studio' ? (fallback.indexOf('工坊') !== -1 || fallback.indexOf('studio') !== -1) : false);
        b.classList.toggle('active', !!isActive);
        b.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      }
      show(mapViewport, mode === 'map');
      show(storyPanel,  mode === 'story');
      show(studioPanel, mode === 'studio');
      if (mode === 'studio' && window.StudioApp && typeof window.StudioApp.init === 'function') { try { window.StudioApp.init(); } catch (_) {} }
      try { document.dispatchEvent(new CustomEvent('littleg:view-changed', { detail: { view: mode } })); } catch (_) {}
    };
  }

  function bindViewButtonsFallback() {
    var btns = document.querySelectorAll('.view-btn[data-target]');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        if (btn.dataset && btn.dataset.lgBound === '1') return;
        if (btn.dataset) btn.dataset.lgBound = '1';
        btn.addEventListener('click', function (e) { e.preventDefault(); var mode = String(btn.getAttribute('data-target') || '').trim(); if (!mode) return; if (typeof window.switchView === 'function') window.switchView(mode); }, { passive: false });
      })(btns[i]);
    }
  }

  function bindStoryFlowHelpers() {
    var openStoryBtn = $id('lg-open-story');
    var skipBtn = $id('lg-skip-story');
    var toStudioBtn = $id('lg-to-studio');
    var toMarketBtn = $id('lg-to-market');
    var iframe = $id('lg-story-iframe');
    function ensureStorySrc() { if (!iframe) return; var src = String(getServerData().storyVideoUrl || '').trim(); if (!src) return; if (iframe.getAttribute('src')) return; iframe.setAttribute('src', src); }
    if (openStoryBtn && !openStoryBtn.__lgBound) { openStoryBtn.__lgBound = true; openStoryBtn.addEventListener('click', function () { ensureStorySrc(); if (typeof window.switchView === 'function') window.switchView('story'); }); }
    if (skipBtn && !skipBtn.__lgBound) { skipBtn.__lgBound = true; skipBtn.addEventListener('click', function () { if (typeof window.switchView === 'function') window.switchView('studio'); }); }
    if (toStudioBtn && !toStudioBtn.__lgBound) { toStudioBtn.__lgBound = true; toStudioBtn.addEventListener('click', function () { if (typeof window.switchView === 'function') window.switchView('studio'); }); }
    if (toMarketBtn && !toMarketBtn.__lgBound) { toMarketBtn.__lgBound = true; toMarketBtn.addEventListener('click', function () { var url = String(getServerData().gfunMarketUrl || '/pages/gfun-dashboard'); window.location.href = url; }); }
  }

  function ensureSvgPaths() {
    var stage = $id('world-stage');
    var svg = document.querySelector('.lg-map-connections');
    if (!stage || !svg) return;
    svg.setAttribute('viewBox', '0 0 1000 800');
    svg.setAttribute('preserveAspectRatio', 'none');
    if (!svg.querySelector('path.lg-path-base')) { var base = document.createElementNS('http://www.w3.org/2000/svg', 'path'); base.setAttribute('class', 'lg-path-base'); base.setAttribute('fill', 'none'); base.setAttribute('stroke', 'rgba(255,255,255,0.18)'); base.setAttribute('stroke-width', '2'); svg.appendChild(base); }
    if (!svg.querySelector('path.lg-path-active')) { var active = document.createElementNS('http://www.w3.org/2000/svg', 'path'); active.setAttribute('class', 'lg-path-active'); active.setAttribute('fill', 'none'); active.setAttribute('stroke', 'rgba(0,212,255,0.95)'); active.setAttribute('stroke-width', '3'); active.setAttribute('stroke-linecap', 'round'); active.setAttribute('stroke-dasharray', '10 10'); svg.appendChild(active); }
    var update = debounce(function () {
      var nodes = Array.prototype.slice.call(document.querySelectorAll('.lg-island-node'));
      if (!nodes || nodes.length < 2) return;
      nodes.sort(function (a, b) { var la = parseInt(a.getAttribute('data-island-level') || '0', 10); var lb = parseInt(b.getAttribute('data-island-level') || '0', 10); return la - lb; });
      function getPct(node, cssVar, fallbackAttr) { var v = ''; try { v = getComputedStyle(node).getPropertyValue(cssVar) || ''; } catch (_) {} v = String(v).replace('%', '').trim(); if (v) return parseFloat(v); var dv = node.getAttribute(fallbackAttr); if (dv) return parseFloat(String(dv).replace('%', '').trim()); return 50; }
      var pts = nodes.map(function (n) { var x = getPct(n, '--pos-x', 'data-x'); var y = getPct(n, '--pos-y', 'data-y'); var locked = (n.getAttribute('data-locked') || '0') === '1' || n.classList.contains('is-locked'); return { x: (x / 100) * 1000, y: (y / 100) * 800, unlocked: !locked }; });
      var dBase = 'M ' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
      for (var i = 0; i < pts.length - 1; i++) { var p1 = pts[i], p2 = pts[i + 1]; var cx = (p1.x + p2.x) / 2; var cy = Math.min(p1.y, p2.y) - 80; dBase += ' Q ' + cx.toFixed(1) + ' ' + cy.toFixed(1) + ', ' + p2.x.toFixed(1) + ' ' + p2.y.toFixed(1); }
      var dActive = 'M ' + pts[0].x.toFixed(1) + ' ' + pts[0].y.toFixed(1);
      for (var j = 0; j < pts.length - 1; j++) { var a1 = pts[j], a2 = pts[j + 1]; var acx = (a1.x + a2.x) / 2; var acy = Math.min(a1.y, a2.y) - 80; if (a1.unlocked && a2.unlocked) dActive += ' Q ' + acx.toFixed(1) + ' ' + acy.toFixed(1) + ', ' + a2.x.toFixed(1) + ' ' + a2.y.toFixed(1); else dActive += ' M ' + a2.x.toFixed(1) + ' ' + a2.y.toFixed(1); }
      var basePath = svg.querySelector('path.lg-path-base');
      var activePath = svg.querySelector('path.lg-path-active');
      if (basePath) basePath.setAttribute('d', dBase);
      if (activePath) activePath.setAttribute('d', dActive);
    }, CONFIG.PATH_UPDATE_DEBOUNCE_MS);
    update();
    if (!svg.__lgPathResizeBound) { svg.__lgPathResizeBound = true; window.addEventListener('resize', update, { passive: true }); }
    if (!document.__lgPathClickBound) { document.__lgPathClickBound = true; document.addEventListener('click', function (e) { var t = e.target; if (t && t.id === 'lg-unlock-confirm') { var currentSvg = document.querySelector('.lg-map-connections'); if (currentSvg && typeof currentSvg.__lgPathUpdate === 'function') setTimeout(currentSvg.__lgPathUpdate, 520); } }, { passive: true }); }
    svg.__lgPathUpdate = update;
  }

  function syncTimeSystemOnce() { var sky = $id('sky-system'); if (!sky) return; var hour = new Date().getHours(); var period = 'night'; if (hour >= 6 && hour < 17) period = 'day'; else if (hour >= 17 && hour < 20) period = 'sunset'; if (sky.dataset && sky.dataset.period !== period) sky.dataset.period = period; }
  function startAutoTimeSync() { syncTimeSystemOnce(); if (window.__LG_TIME_SYNC_INTERVAL) return; window.__LG_TIME_SYNC_INTERVAL = setInterval(syncTimeSystemOnce, CONFIG.AUTO_TIME_INTERVAL_MS); }
  function findIslandNodeByHandle(handle) { var value = String(handle || ''); if (!value) return null; if (window.CSS && typeof window.CSS.escape === 'function') { try { return document.querySelector('.lg-island-node[data-handle="' + window.CSS.escape(value) + '"]'); } catch (_) {} } var nodes = document.querySelectorAll('.lg-island-node[data-handle]'); for (var i = 0; i < nodes.length; i++) { if (String(nodes[i].getAttribute('data-handle') || '') === value) return nodes[i]; } return null; }
  function handleReturnNavigation() { var qs = window.location.search || ''; if (!qs) return; var params; try { params = new URLSearchParams(qs); } catch (_) { return; } var returnFrom = params.get('return_from'); if (!returnFrom) return; var node = findIslandNodeByHandle(returnFrom); if (!node) return; setTimeout(function () { try { node.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' }); } catch (_) {} node.classList.add('highlight-return-island'); setTimeout(function () { node.classList.remove('highlight-return-island'); }, CONFIG.RETURN_HIGHLIGHT_MS); }, 450); try { var url = new URL(window.location.href); url.searchParams.delete('return_from'); window.history.replaceState({}, '', url.toString()); } catch (_) {} }
  function applyDefaultViewFromServerData() { var s = getServerData(); var viewMode = String(s.viewMode || '').trim(); if (viewMode === 'map_view' && typeof window.switchView === 'function') window.switchView('map'); }

  function start(scope) {
    markLegacyLab(document.documentElement);
    if (isNatureRoute()) { bootNatureRoute(); hydratePhaseBadges(); return; }
    var rootScope = scope && scope.nodeType ? scope : document;
    var wrapper = rootScope.querySelector && rootScope.querySelector('.littleg-main-wrapper') || document.querySelector('.littleg-main-wrapper');
    if (!wrapper) return;
    markLegacyLab(wrapper);
    ensureSwitchView();
    bindViewButtonsFallback();
    removeBootScreen();
    ensureSvgPaths();
    handleReturnNavigation();
    startAutoTimeSync();
    bindStoryFlowHelpers();
    hydratePhaseBadges();
    applyDefaultViewFromServerData();
    try { if (typeof window.initIslandUnlockStatus === 'function' && !window.__LG_ISLAND_INIT_CALLED) { window.__LG_ISLAND_INIT_CALLED = true; window.initIslandUnlockStatus(); } } catch (_) {}
    log('[littleg-lab-init] Booted LEGACY-CLEANUP-15', { viewMode: getServerData().viewMode, isLoggedIn: !!getServerData().isLoggedIn });
  }

  function boot() {
    if (window.__LITTLEG_LAB_INIT_V53_BOOT_BOUND) { start(document); return; }
    window.__LITTLEG_LAB_INIT_V53_BOOT_BOUND = true;
    var started = false;
    function safeStart(scope) { if (started && (!scope || scope === document)) return; if (!scope || scope === document) started = true; start(scope || document); }
    window.addEventListener('littleg:config:ready', function () { safeStart(document); }, { once: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(function () { safeStart(document); }, 0); }, { once: true }); else setTimeout(function () { safeStart(document); }, 0);
    setTimeout(function () { safeStart(document); }, 2500);
    document.addEventListener('shopify:section:load', function (event) { safeStart(event && event.target ? event.target : document); });
  }

  function bootLegacyIslandSlider() {
    var root = document.getElementById('littleg-lab-island');
    if (!root || root.__legacyIslandSliderReady) return;
    root.__legacyIslandSliderReady = true;
    markLegacyLab(root);
    root.setAttribute('data-legacy-island-slider-owner', 'littleg-lab-init');
    root.setAttribute('data-legacy-phase-model', 'p1-p6');
    var slider = root.querySelector('#islands-slider');
    var phaseBtns = Array.prototype.slice.call(root.querySelectorAll('.level-btn'));
    var islandBtns = Array.prototype.slice.call(root.querySelectorAll('.island-btn'));
    var languageSwitcher = document.getElementById('littleg-language-switcher');

    function detectLanguage() {
      var savedLang = localStorage.getItem('littleg-language');
      if (savedLang) return savedLang;
      var locale = document.documentElement.lang || 'zh-TW';
      if (locale.indexOf('zh-CN') >= 0 || locale.indexOf('zh-cn') >= 0) return 'zh-cn';
      if (locale.indexOf('zh-TW') >= 0 || locale.indexOf('zh-tw') >= 0) return 'zh-tw';
      if (locale.indexOf('en') >= 0) return 'en';
      return 'zh-tw';
    }

    function switchToPhase(phase, moveFocus) {
      if (!slider || phase < 1 || phase > 6) return;
      slider.style.transform = 'translateX(' + (-(phase - 1) * 100) + 'vw)';

      phaseBtns.forEach(function (btn) {
        var active = parseInt(btn.dataset.phase, 10) === phase;
        btn.classList.toggle('active', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.setAttribute('tabindex', active ? '0' : '-1');
        if (active && moveFocus) btn.focus();
      });

      localStorage.setItem('littleg-current-phase', phase);
    }

    function updateLanguage(lang) {
      root.querySelectorAll('.phase-label').forEach(function (el) {
        var text = el.getAttribute('data-' + lang);
        if (text) el.textContent = text;
      });
      root.querySelectorAll('.phase-title-multilang').forEach(function (el) {
        var text = el.getAttribute('data-' + lang);
        if (text) el.textContent = text;
      });
      localStorage.setItem('littleg-language', lang);
      document.documentElement.lang = lang;
    }

    phaseBtns.forEach(function (btn, index) {
      var phase = parseInt(btn.dataset.phase, 10);
      btn.setAttribute('role', 'button');
      btn.setAttribute('aria-pressed', 'false');
      btn.setAttribute('tabindex', '-1');
      btn.setAttribute('aria-label', (btn.textContent || ('Phase ' + phase)).replace(/\s+/g, ' ').trim());

      btn.addEventListener('click', function () {
        switchToPhase(phase, false);
      });

      btn.addEventListener('keydown', function (event) {
        var nextIndex = index;

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          switchToPhase(phase, false);
          return;
        }

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (index + 1) % phaseBtns.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (index - 1 + phaseBtns.length) % phaseBtns.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = phaseBtns.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        switchToPhase(parseInt(phaseBtns[nextIndex].dataset.phase, 10), true);
      });
    });

    islandBtns.forEach(function (btn) {
      var unlocked = btn.dataset.unlocked === 'true';
      btn.setAttribute('aria-disabled', unlocked ? 'false' : 'true');

      btn.addEventListener('click', function () {
        var url = btn.dataset.url;
        if (unlocked && url && url !== '#') window.location.href = url;
      });

      btn.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          btn.click();
        }
      });
    });

    if (languageSwitcher) {
      var currentLang = detectLanguage();
      languageSwitcher.value = currentLang;
      updateLanguage(currentLang);
      languageSwitcher.addEventListener('change', function (event) {
        updateLanguage(event.target.value);
        window.dispatchEvent(new CustomEvent('littleg:languageChanged', {
          detail: { language: event.target.value }
        }));
      });
    }

    var savedPhase = parseInt(localStorage.getItem('littleg-current-phase') || '1', 10);
    if (!savedPhase || savedPhase < 1 || savedPhase > 6) savedPhase = 1;
    switchToPhase(savedPhase, false);
  }

  boot();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootLegacyIslandSlider); else bootLegacyIslandSlider();
  document.addEventListener('shopify:section:load', bootLegacyIslandSlider);
})();